import { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [accountType, setAccountType] = useState('none');

  const setUserData = (userData) => {
    setUser(userData);
    setIsAdmin(userData?.level === "10");
  };

  const handleLogout = () => {
    setUser(null);
    setIsAdmin(false);
    setAccountType("none");
  };

  useEffect(() => {
    const handleLogout = () => setUser(null);

    window.addEventListener("user:logout", handleLogout);

    return () => window.removeEventListener("user:logout", handleLogout);
  }, []);

  return (
    <UserContext.Provider value={{ user, isAdmin, setUserData, accountType, setAccountType, handleLogout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
